<template>
  <div class="content scroll-area">
    <div class="delivery-loading" v-if="loading">
      <a-spin :spinning="loading"></a-spin>
    </div>
    <div class="delivery-detail" v-else-if="info">
      <div class="other-title">提交详情</div>
      <div class="delivery-form-content">
        <detail-list :list="infoList">
          <template v-slot:car="{ value }">
            <a-space direction="vertical" v-if="Array.isArray(value)">
              <a-tag v-for="c in value" :key="c.id">{{c.activityDeliverySet.chinese_name}}*{{c.num}}</a-tag>
            </a-space>
            <span v-else>{{ value || '无'}}</span>
          </template>
        </detail-list>
      </div>
      <a-space align="center" class="other-title flex-box align-center" style="margin-top: 16px">
        <span>车辆信息</span>
        <a-button type="primary" @click="addCar"><a-icon type="plus-circle"/>新增车辆</a-button>
      </a-space>
      <div class="delivery-car">
        <div class="delivery-car-list" v-if="carList.length > 0">
          <a-card size="small" :bodyStyle="{padding: 0}" class="delivery-car-item" :title="`车辆${i + 1}`" v-for="(car, i) in carList" :key="car.id">
            <div class="row-btn" slot="extra">
              <template v-if="car.edit">
                <a class="txt-btn grey" @click="cancel(i)">取消</a>
                <a class="txt-btn" @click="save(i)">保存</a>
              </template>
              <template v-else>
                <a class="txt-btn danger" @click="delCar(i)">删除</a>
                <a class="txt-btn" @click="editCar(i)">编辑</a>
              </template>
            </div>
            <form-area
              :ref="`car_form_${i}`"
              layout="horizontal"
              hide-btn
              :label-col="{ span: 8 }"
              :wrapper-col="{ span: 16 }"
              :items="items"
              :entity="car"
              v-if="car.edit"
            >
            </form-area>
            <div class="delivery-car-detail" v-else >
              <detail-list :list="car.infoList" full />
            </div>
          </a-card>
        </div>
        <a-empty :image="simpleImage" description="暂无车辆信息" v-else/>
      </div>
    </div>
  </div>
</template>

<script lang="tsx">
    import {Empty} from "ant-design-vue";
    import DetailList from "../../../layouts/DetailList.vue";
    export default {
        name: "DeliveryDetail",
        components: {
            DetailList
        },
        data() {
            return {
                info: null,
                loading: false,
                simpleImage: Empty.PRESENTED_IMAGE_SIMPLE,
                carList: []
            }
        },
        computed: {
            id() {
                return this.$route.params.carId;
            },
            items() {
                return [
                    {
                        key: 'activity_delivery_set_id',
                        label: '车型',
                        component: 'a-select',
                        props: {
                            placeholder: '请选择车型',
                            options: this.info.deliveryInfo.filter(d => !!d.activityDeliverySet).map(c => {
                                return {
                                    value: c.activityDeliverySet.id,
                                    label: c.activityDeliverySet.chinese_name
                                }
                            })
                        },
                        rules: [{ required: true, message: '请选择车型', trigger: 'change' }]
                    },
                    {
                        key: 'car_num',
                        label: '车牌号',
                        component: 'a-input',
                        props: {
                            placeholder: '请输入车牌号'
                        },
                        rules: [{ required: true, message: '请输入车牌号', trigger: 'blur' }]
                    },
                    {
                        key: 'driver_name',
                        label: '司机姓名',
                        component: 'a-input',
                        props: {
                            placeholder: '请输入司机姓名'
                        },
                        rules: [{ required: true, message: '请输入司机姓名', trigger: 'blur' }]
                    },
                    {
                        key: 'driver_mobile',
                        label: '联系方式',
                        component: 'a-input',
                        props: {
                            placeholder: '请输入司机联系方式'
                        },
                        rules: [{ required: true, message: '请输入司机联系方式', trigger: 'blur' }]
                    },
                    {
                        key: 'accompany_name',
                        label: '陪同人员',
                        component: 'a-input',
                        props: {
                            placeholder: '请输入陪同人员'
                        },
                    },
                    {
                        key: 'accompany_mobile',
                        label: '陪同人员联系方式',
                        component: 'a-input',
                        props: {
                            placeholder: '请输入陪同人员联系方式'
                        },
                        rules: [
                            { required: false, message: '请输入陪同人员联系方式', trigger: 'blur' }
                        ]
                    },
                    {
                        key: 'notes',
                        label: '备注',
                        component: 'a-textarea',
                        props: {
                            placeholder: '请输入',
                            maxLength: 100,
                            rows: 4
                        },
                    },
                ]
            },
            infoList() {
                let res = [];
                const info = this.info;
                if (info) {
                    res = [
                        { label: '提交时间', value: info.create_time, key: 'create_time' },
                        { label: '车型', value: info.deliveryInfo, key: 'car', scopedSlot: 'car' },
                        { label: '接站地点', value: info.location, key: 'location' },
                        { label: '航班/车次', value: info.train_flight, key: 'train_flight' },
                        { label: '接站时间', value: info.arrival_time, key: 'arrival_time' },
                        { label: '送站地点', value: info.leave_location, key: 'leave_location' },
                        { label: '姓名', value: info.user_name, key: 'user_name' },
                        { label: '联系方式', value: info.mobile, key: 'mobile' },
                        { label: '邮箱', value: info.email, key: 'email' },
                    ]
                }
                return res;
            },
        },
        watch: {
            id() {
                this.getDetail();
            }
        },
        created() {
            this.getDetail();
        },
        methods: {
            save(i) {
                this.$refs[`car_form_${i}`][0].handleConfirm().then(form => {
                    const car = this.carList[i];
                    let url = "/activity/delivery-car", method = "POST";
                    if (car.id) {
                        url += `/${car.id}`;
                        method = "PATCH";
                    }
                    this.$axios({
                        url,
                        method,
                        data: {
                            ...form,
                            activity_id: this.info.activity_id,
                            delivery_service_id: this.info.id
                        }
                    }).then(res => {
                        res.activityDeliverySet = this.info.deliveryInfo.find(d => d.activity_delivery_set_id === res.activity_delivery_set_id).activityDeliverySet;
                        this.$set(this.carList, i, {...res, infoList: this.getCarInfoList(res)});
                        this.$message.success("已保存");
                    })
                })
            },
            cancel(i) {
                const car = this.carList[i];
                if (car.id) {
                    this.$set(car, 'edit', false);
                } else {
                    this.carList.splice(i, 1);
                }
            },
            delCar(i) {
                this.$confirm({
                    title: "提示",
                    content: "确定删除此车辆吗？",
                    onOk: () => {
                        const car = this.carList[i];
                        this.$axios({
                            url: `/activity/delivery-car/${car.id}`,
                            method: "DELETE"
                        }).then(() => {
                            this.carList.splice(i, 1);
                            this.$message.success("已删除");
                        })
                    }
                })
            },
            addCar() {
                this.carList.push({
                    edit: true
                })
            },
            editCar(i) {
                const car = this.carList[i];
                this.$set(car, 'edit', true);
            },
            setCarList() {
                let res = [];
                const info = this.info;
                if (info && info.deliveryCar) {
                    res = info.deliveryCar.map(c => {
                        return {
                            ...c,
                            infoList: this.getCarInfoList(c)
                        }
                    })
                }
                this.carList = res;
            },
            getCarInfoList(car) {
                return [
                    { label: '车型', value: car.activityDeliverySet.chinese_name, key: 'car_type' },
                    { label: '车牌', value: car.car_num, key: 'car_num' },
                    { label: '司机姓名', value: car.driver_name, key: 'driver_name' },
                    { label: '联系方式', value: car.driver_mobile, key: 'driver_mobile' },
                    { label: '陪同人员', value: car.accompany_name, key: 'accompany_name' },
                    { label: '陪同人员联系方式', value: car.accompany_mobile, key: 'accompany_mobile' },
                    { label: '备注', value: car.notes, key: 'notes' },
                ]
            },
            getDetail() {
                const id = this.id;
                if (!id) return;
                this.loading = true;
                this.$axios(`/activity/delivery-service/${id}?expand=deliveryCar.activityDeliverySet,deliveryInfo.activityDeliverySet`).then(res => {
                    this.info = res;
                    this.setCarList();
                }).finally(() => {
                    this.loading = false;
                });
            }
        }
    }
</script>

<style scoped lang="less">
  .delivery-loading {
    text-align: center;
  }
  .delivery-form-content {
    max-width: 1080px;
  }
  .delivery-car-list {
    display: flex;
    gap: 32px;
  }
  .delivery-car-item {
    width: 480px;
  }
  .delivery-car-detail {
    padding: 16px;
  }
</style>
